export const siteInfo = {
  name: '91网',
  slogan: '资源整合 · 服务入口 · 一站直达',
  description: '91网是您的首选平台，提供全面的资源整合与服务入口。',
  copyright: '© 2026 91网 版权所有',
  beian: '京ICP备2026000001号',
  address: '北京市海淀区中关村科技园区',
  phone: '400-888-9191',
  email: 'service@91wang.com',
  wechat: '91wang_official',
  foundedYear: '2018',
  stats: [
    { label: '注册用户', value: '500万+' },
    { label: '日活跃用户', value: '80万+' },
    { label: '入驻服务商', value: '3000+' },
    { label: '累计服务次数', value: '2亿+' },
  ],
};

export const navLinks = [
  { label: '首页', href: '/', icon: 'ri-home-4-line' },
  { label: '资源分类', href: '/category/all', icon: 'ri-grid-line' },
  { label: '关于我们', href: '/about', icon: 'ri-information-line' },
];

export const heroSlides = [
  {
    title: '91网 — 您的智能资源门户',
    subtitle: '汇聚全网优质资源，打造一站式服务平台',
    cta: '立即探索',
    ctaLink: '/category/all',
    secondaryCta: '了解更多',
    secondaryCtaLink: '/about',
  },
];

export const features = [
  {
    icon: 'ri-global-line',
    title: '资源整合',
    description: '聚合全网优质内容与服务资源，省去多平台切换的繁琐步骤，一站直达所需。',
    href: '/category/resources',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '所有入驻服务商均经过严格审核，确保信息真实有效，保障您的使用安全。',
    href: '/about',
  },
  {
    icon: 'ri-flashlight-line',
    title: '高效便捷',
    description: '智能搜索与精准推荐，帮您快速找到所需资源，大幅提升工作和生活效率。',
    href: '/category/all',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '会员权益',
    description: '注册会员享专属优惠、优先体验新功能、专属客服等多项权益。',
    href: '/about',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '专属客服',
    description: '7×24小时在线客服支持，专业团队随时为您解答疑问。',
    href: '/about',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    description: '支持PC端、移动端无缝切换，随时随地访问您的资源。',
    href: '/category/all',
  },
];

export const stats = [
  { value: '500万+', label: '注册用户' },
  { value: '80万+', label: '日活跃用户' },
  { value: '3000+', label: '入驻服务商' },
  { value: '2亿+', label: '累计服务次数' },
];

export const membershipPlans = [
  {
    name: '免费会员',
    price: '0',
    period: '永久免费',
    color: 'secondary',
    features: [
      '基础资源浏览',
      '每日搜索10次',
      '社区基础功能',
      '标准客服支持',
    ],
    cta: '免费注册',
    highlighted: false,
  },
  {
    name: '高级会员',
    price: '99',
    period: '/年',
    color: 'primary',
    features: [
      '全部资源浏览',
      '无限次搜索',
      '专属资源推荐',
      '优先客服响应',
      '去广告体验',
      '新功能优先体验',
    ],
    cta: '立即开通',
    highlighted: true,
  },
  {
    name: '企业会员',
    price: '299',
    period: '/年',
    color: 'accent',
    features: [
      '高级会员全部权益',
      '团队协作功能',
      'API接口接入',
      '专属客户经理',
      '定制化资源服务',
      '数据报表导出',
    ],
    cta: '联系客服',
    highlighted: false,
  },
];

export const testimonials = [
  {
    name: '张先生',
    role: '互联网从业者',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20portrait%20of%20a%20middle-aged%20man%20in%20casual%20attire%2C%20clean%20white%20background%2C%20warm%20friendly%20expression%2C%20soft%20studio%20lighting%2C%20high%20quality%20headshot&width=120&height=120&seq=avatar-01&orientation=squarish',
    content: '自从用了91网，找资源效率提升了不止一倍。以前要在各个网站之间来回切换，现在一个平台全搞定！',
  },
  {
    name: '李女士',
    role: '自由职业者',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20portrait%20of%20a%20woman%20in%20her%20thirties%2C%20clean%20white%20background%2C%20confident%20smile%2C%20soft%20studio%20lighting%2C%20high%20quality%20headshot&width=120&height=120&seq=avatar-02&orientation=squarish',
    content: '高级会员真的很值！无限搜索和专属推荐功能帮我在项目中节省了大量时间，强烈推荐给大家。',
  },
  {
    name: '王先生',
    role: '创业公司CEO',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20portrait%20of%20a%20man%20in%20his%20forties%2C%20clean%20white%20background%2C%20authoritative%20expression%2C%20soft%20studio%20lighting%2C%20high%20quality%20headshot&width=120&height=120&seq=avatar-03&orientation=squarish',
    content: '企业会员的团队协作和API接入功能对我们公司帮助很大，是团队资源管理的利器。',
  },
];

export const faqs = [
  {
    question: '91网是什么平台？',
    answer: '91网是一个综合性的资源整合与服务平台，聚合了全网各类优质内容和服务资源，为用户提供便捷的一站式资源导航和使用体验。无论您需要学习资料、工具软件、行业资讯还是生活服务，91网都能帮您快速找到。',
  },
  {
    question: '如何注册91网账号？',
    answer: '点击页面右上角的"注册"按钮，填写您的手机号或邮箱地址，设置密码并完成验证即可注册。注册过程简单快捷，通常只需1-2分钟即可完成。注册后您将自动成为免费会员。',
  },
  {
    question: '免费会员和高级会员有什么区别？',
    answer: '免费会员可浏览基础资源和每日10次搜索。高级会员（99元/年）享有无限制搜索、专属资源推荐、优先客服响应、去广告体验和新功能优先体验等多项权益，性价比极高。',
  },
  {
    question: '如何升级到高级会员？',
    answer: '登录后进入"个人中心"页面，点击"会员升级"，选择高级会员计划并完成支付即可立即升级。支持微信支付和支付宝两种支付方式，升级后所有权益即时生效。',
  },
  {
    question: '91网的资源是否安全可靠？',
    answer: '是的。91网对所有入驻的服务商和资源提供方均进行严格的身份审核和资质验证。我们建立了完善的内容审核机制，确保平台上的所有资源信息真实、安全、可靠。同时，我们也鼓励用户在使用后对资源进行评价，共同维护平台生态。',
  },
  {
    question: '遇到问题如何联系客服？',
    answer: '您可以通过以下方式联系我们的客服团队：1）在线客服：页面右下角的客服图标，7×24小时在线；2）客服电话：400-888-9191；3）电子邮箱：service@91wang.com；4）微信公众号：91wang_official。我们的专业客服团队会在最短时间内为您解决问题。',
  },
];